import { ToastAction } from '@/app/components/ui/toast';
import { toast } from '@/app/components/ui/use-toast';

interface ShowUpgradeToastOptions {
  /** 提示文案 */
  message: string;
  /** 升级按钮文案 */
  actionText: string;
  /** 点击升级按钮的回调，通常是打开套餐弹窗 */
  onAction: () => void;
}

/**
 * 升级引导 toast：替代原先直接弹出的订阅弹窗，避免打断用户操作的连贯性。
 * 用户仍可通过 toast 内的升级按钮进入套餐弹窗，转化路径不丢失。
 */
export const showUpgradeToast = ({ message, actionText, onAction }: ShowUpgradeToastOptions) => {
  toast({
    type: 'custom',
    message,
    duration: 5000,
    containerClassName:
      'fixed top-[72px] left-1/2 z-[100] flex w-fit -translate-x-1/2 items-center justify-center gap-3 rounded-[100px] border-none bg-[#2E2F33] px-6 py-4 text-white shadow-none backdrop-blur-[20px]',
    contentClassName: 'font-semibold text-sm text-white leading-5 opacity-100',
    action: (
      <ToastAction
        altText={actionText}
        onClick={onAction}
        className="h-auto rounded-6 border-none bg-ShengshuButton px-3 py-1 font-semibold text-black text-xs hover:bg-ShengshuButtonHover"
      >
        {actionText}
      </ToastAction>
    ),
  });
};
